import React, {useContext} from 'react';
import { Dropdown } from 'react-bootstrap';
import CustomToggle from './customToggler';
import { BaseContext, ConversationContext } from '../contexts/baseContext';


export function CustomDropdownProfil({ children, onSelectImage }) {
  return (
    <Dropdown>
      <Dropdown.Toggle
        as={CustomToggle}
      >
        { children }
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href="#" className="dropdown-item-text" onClick={() => onSelectImage()}>
          <i className="bi bi-pen mr-3 icon-dropdown"></i>
          <span>Change photo</span>
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item href="#" className="dropdown-item-text">
          <i className="bi bi-trash mr-3 icon-dropdown"></i>
          <span>Delete photo</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export function CustomDropdownContact({ children, id, show }) {
  const { touchContact } = useContext(BaseContext);

  return (
    <Dropdown>
      <Dropdown.Toggle
        as={CustomToggle}
        show={show}
      >
        { children }
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href="#" onClick={() => touchContact(id)} className="dropdown-item-text">
          <i className="bi bi-box-arrow-in-left mr-3 icon-dropdown"></i>
          <span>Open</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export function CustomDropdownMessage({ children, type, show, idMessage }) {
  const { removeMessage } = useContext(BaseContext);
  const { setIdMessageIndexed } = useContext(ConversationContext);

  return (
    <Dropdown>
      <Dropdown.Toggle
        as={CustomToggle}
        show={show}
      >
        { children }
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href="#" className="dropdown-item-text" onClick={() => setIdMessageIndexed(idMessage)}>
          <i className="bi bi-reply mr-3 icon-dropdown"></i>
          <span>Reply</span>
        </Dropdown.Item>
        {
          type === "sended" ? <>
            <Dropdown.Divider />
            <Dropdown.Item href="#" className="dropdown-item-text" onClick={() => removeMessage(idMessage)}>
              <i className="bi bi-trash mr-3 icon-dropdown"></i>
              <span>Delete</span>
            </Dropdown.Item>
          </> : null
        }
      </Dropdown.Menu>
    </Dropdown>
  );
}

export function CustomDropdownConversation({ children, show }) {
  const { navigateTo } = useContext(BaseContext);

  return (
    <Dropdown>
      <Dropdown.Toggle
        as={CustomToggle}
        show={show}
      >
        { children }
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href="#" className="dropdown-item-text conv-drop-item"  onClick={() => navigateTo("profil-contact")}>
          <i className="bi bi-info-circle mr-3 icon-dropdown"></i>
          <span>Show Contact</span>
        </Dropdown.Item>

        <Dropdown.Item href="#" className="dropdown-item-text conv-drop-item">
          <i className="bi bi-files mr-3 icon-dropdown"></i>
          <span>Files</span>
        </Dropdown.Item>

        <Dropdown.Item href="#" className="dropdown-item-text conv-drop-item">
          <i className="bi bi-search mr-3 icon-dropdown"></i>
          <span>Research</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
